import { render, staticRenderFns } from "./BaseButtonV2.vue?vue&type=template&id=0e75644a&scoped=true&"
import script from "./BaseButtonV2.vue?vue&type=script&lang=js&"
export * from "./BaseButtonV2.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonV2.vue?vue&type=style&index=0&id=0e75644a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e75644a",
  null
  
)

export default component.exports